<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title"><i class="fa fa-minus-square"></i> {{title | translate}}</h4>
  </div>
  <div class="modal-body">
    <div>
      <div class="custom-div">
        <span class="custom-span">
          <i class="fas fa-exclamation-circle text-warning"></i>
        </span>
        <label class="custom-label">{{body | translate}}</label>
      </div>
      <div class="row"></div>
      <div class="row">
        <div class="col font-weight-bold col-form-label">
          {{ "LABEL.MOTIVE" | translate }}
        </div>
      </div>
      <div class="row">
        <div class="col">
          <textarea type="text"
                    class="form-control"
                    placeholder="{{ 'MESSAGE.ENTER-REASON-CANCELLATION' | translate }}"
                    [(ngModel)]="observationcancel.description" [rows]="4">
                  </textarea>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-success"
            (click)="yes()">
      <i class="fas fa-thumbs-up"></i> {{ 'BUTTON.YES' | translate }}</button>
    <button type="button" class="btn btn-outline-secondary"
            (click)="no()">
      <i class="fa fa-times-circle"></i>  {{ 'BUTTON.NO' | translate }}</button>
  </div>
</div>
<app-loading *ngIf="loading"></app-loading>
